var render, staticRenderFns
import script from "./CouponPageQuick.vue?vue&type=script&lang=ts&"
export * from "./CouponPageQuick.vue?vue&type=script&lang=ts&"
import style0 from "./CouponPageQuick.vue?vue&type=style&index=0&id=5edf8cab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5edf8cab",
  null
  
)

export default component.exports